import React, { Fragment, useState, useRef, useEffect } from "react";
import { Link } from "react-router-dom";
import "react-datepicker/dist/react-datepicker.css";
import { storage, db } from "../../../firebase";
import { ref, getDownloadURL, deleteObject, listAll } from "firebase/storage";
import { useCollection } from "../../../hook/useCollection";
import { query, getDocs, getDoc, collection, where } from "firebase/firestore";
import { safeConvertToISODate } from "../../../utils/dateUtils";
export default ({
  name,
  label,
  type,
  value,
  initailValue,
  onChange,
  options,
  disabled,
  required,
  description,
  fileNames,
  defaultfiles,
  onViewFile,
  product,
  ticketId,
  viewonly,
  onProductFound,
}) => {
  // let productDetail = [];
  // const onSearch = async() => {
  //   const q = query(
  //     collection(db, "orders"),
  //     where("productSn", "==", product)
  //   );
  //   const querySnapshot = await getDocs(q);

  //   // console.log(querySnapshot);
  //   querySnapshot.forEach((doc) => {
  //     // doc.data() is never undefined for query doc snapshots
  //     productDetail.push(doc.data());
  //   });
  //   console.log(productDetail);
  // };
  const onSearch = async (e) => {
    e.preventDefault();

    try {
      // Search in saleOrders collection - use manual filtering since array-contains-any with objects is complex
      const saleOrdersSnapshot = await getDocs(collection(db, "saleOrders"));
      const matchingOrders = [];

      saleOrdersSnapshot.forEach((doc) => {
        const orderData = doc.data();
        if (orderData.items && Array.isArray(orderData.items)) {
          const hasMatchingCpap = orderData.items.some(
            (item) => item.productType === "CPAP" && item.productSn === product
          );
          if (hasMatchingCpap) {
            matchingOrders.push(orderData);
          }
        }
      });

      if (matchingOrders.length > 0) {
        const orderData = matchingOrders[0];
        await populateFormData(orderData);
      } else {
        // Fallback to legacy orders collection
        await searchLegacyOrders();
      }
    } catch (error) {
      console.error("Error in search:", error);
      // Fallback to legacy search
      await searchLegacyOrders();
    }
  };

  const populateFormData = async (orderData) => {
    // Get product details
    const cpapItem = orderData.items
      ? orderData.items.find(
          (item) => item.productType === "CPAP" && item.productSn === product
        )
      : null;

    if (cpapItem) {
      // Get detailed product info from products collection
      const productq = query(
        collection(db, "products"),
        where("serialNumber", "==", product)
      );
      const productQuerySnapshot = await getDocs(productq);
      const productDetails = [];
      productQuerySnapshot.forEach((doc) => {
        productDetails.push(doc.data());
      });

      // Convert warranty date (using safe conversion)
      const warrantyDate = safeConvertToISODate(orderData.warrantyEndDate);
      const purchaseDate = safeConvertToISODate(orderData.receiptDate);

      // Call the callback with the found data
      if (onProductFound) {
        const dataToSend = {
          firstname: orderData.firstname || "",
          lastname: orderData.lastname || "",
          refCustomer: orderData.refCustomer || "",
          mobile: orderData.mobile || "",
          nodeRef: orderData.nodeRef || "",
          warranty: warrantyDate,
          productSn: product,
          purchaseDate: purchaseDate || "",
          hn: orderData.hn || "",
          brand:
            (productDetails[0] && productDetails[0].brand) ||
            cpapItem.productBrand ||
            "",
          model: (productDetails[0] && productDetails[0].model) || "",
        };

        onProductFound(dataToSend);
      }
    }
  };

  const searchLegacyOrders = async () => {
    const orderq = query(
      collection(db, "orders"),
      where("productSn", "==", product)
    );
    const orderQuerySnapshot = await getDocs(orderq);

    const productq = query(
      collection(db, "products"),
      where("serialNumber", "==", product)
    );
    const productQuerySnapshot = await getDocs(productq);

    const legacyOrderDetail = [];
    const legacyProductDetail = [];

    orderQuerySnapshot.forEach((doc) => {
      legacyOrderDetail.push(doc.data());
    });
    productQuerySnapshot.forEach((doc) => {
      legacyProductDetail.push(doc.data());
    });

    // If product found and callback provided, populate the form
    if (legacyOrderDetail.length > 0 && onProductFound) {
      const orderData = legacyOrderDetail[0];

      // Convert warranty date from Firestore timestamp (using safe conversion)
      const warrantyDate = safeConvertToISODate(orderData.warrantyEndDate);
      const purchaseDate = safeConvertToISODate(orderData.receiptDate);

      // Call the callback with the found data
      const legacyDataToSend = {
        firstname: orderData.firstname || "",
        lastname: orderData.lastname || "",
        refCustomer: orderData.refCustomer || "",
        mobile: orderData.mobile || "",
        nodeRef: orderData.nodeRef || "",
        warranty: warrantyDate,
        productSn: orderData.productSn || "",
        purchaseDate: purchaseDate || "",
        hn: orderData.hn || "",
        brand: (legacyProductDetail[0] && legacyProductDetail[0].brand) || "",
        model: (legacyProductDetail[0] && legacyProductDetail[0].model) || "",
      };

      onProductFound(legacyDataToSend);
    } else if (legacyProductDetail.length > 0 && onProductFound) {
      // If no order found but product exists, at least populate product info
      onProductFound({
        firstname: "",
        lastname: "",
        refCustomer: "",
        mobile: "",
        nodeRef: "",
        warranty: "",
        productSn: product,
        purchaseDate: "",
        hn: "",
        brand: (legacyProductDetail[0] && legacyProductDetail[0].brand) || "",
        model: (legacyProductDetail[0] && legacyProductDetail[0].model) || "",
      });
    } else {
      alert("No product found with this serial number");
    }
  };

  return (
    <div className="form-group row m-1">
      <label label className="col-lg-4 col-form-label">
        {label}
        {required && <span className="text-danger">*</span>}
      </label>

      <div className="col-lg-6">
        {type === "select" ? (
          <div>
            <select
              key={name}
              className="form-control"
              defaultValue={initailValue}
              onChange={onChange}
              disabled={disabled || viewonly}
            >
              {!initailValue && <option value={null}>please-select</option>}
              {options.map((opt) => (
                <option value={opt}>{opt}</option>
              ))}
            </select>
            <span className="text-danger">
              <small>{description}</small>
            </span>
          </div>
        ) : type === "text" || type === "number" ? (
          <div>
            {name === "hn" ? (
              <input
                key={name}
                className="form-control"
                type={type}
                name={name}
                value={value}
                onChange={onChange}
                disabled={disabled || viewonly}
                required={required}
              />
            ) : value !== undefined && value !== null && value !== "" ? (
              <input
                key={name}
                className="form-control"
                type={type}
                name={name}
                value={value}
                onChange={onChange}
                disabled={disabled || viewonly}
                required={required}
              />
            ) : (
              <input
                key={name}
                className="form-control"
                type={type}
                name={name}
                defaultValue={initailValue}
                onChange={onChange}
                disabled={disabled || viewonly}
                required={required}
              />
            )}
            <small>{description}</small>
          </div>
        ) : type === "date" || type === "time" ? (
          <>
            {value !== undefined && value !== null && value !== "" ? (
              <input
                key={name}
                className="form-control"
                placeholder="dd-mm-yyyy"
                type={type}
                name={name}
                value={value}
                onChange={onChange}
                disabled={disabled || viewonly}
                required={required}
              />
            ) : (
              <input
                key={name}
                className="form-control"
                placeholder="dd-mm-yyyy"
                type={type}
                name={name}
                defaultValue={initailValue}
                onChange={onChange}
                disabled={disabled || viewonly}
                required={required}
              />
            )}
          </>
        ) : type === "textarea" ? (
          <textarea
            key={name}
            className="form-control"
            type={type}
            name={name}
            rows={"3"}
            onChange={onChange}
            defaultValue={initailValue}
            disabled={disabled || viewonly}
            required={required}
          />
        ) : type === "file" ? (
          <div className="basic-form custom_file_input">
            <div className="input-group">
              <div className="custom-file">
                <input
                  key={name}
                  type="file"
                  multiple
                  className="custom-file-input"
                  onChange={onChange}
                  disabled={disabled || viewonly}
                />

                {fileNames.length > 0 ? (
                  <label className="custom-file-label">{fileNames}</label>
                ) : (
                  <label className="custom-file-label">choose file</label>
                )}
              </div>
            </div>
            {/* {defaultfiles.length > 0 && (
              <span className="text-info">
                <Link
                  key={defaultfiles}
                  to="#"
                  onClick={() => onViewFile(ticketId, defaultfiles)}
                >
                  <small>{defaultfiles}</small>
                </Link>
              </span>
            )} */}
            {defaultfiles.length > 0 &&
              defaultfiles.map((item) => {
                return (
                  <span className="text-info">
                    <Link
                      key={item}
                      to="#"
                      onClick={() => onViewFile(ticketId, item)}
                    >
                      <small>{item}</small>
                    </Link>
                  </span>
                );
              })}
          </div>
        ) : type === "radio" ? (
          <div className="basic-form">
            {options.map((opt) => (
              <div key={opt} className="form-check">
                <input
                  className="form-check-input"
                  type="radio"
                  name={name}
                  value={opt}
                  onChange={onChange}
                  defaultChecked={initailValue === opt}
                />
                <label className="form-check-label">{opt}</label>
              </div>
            ))}
            <span className="text-danger">
              <small>{description}</small>
            </span>
          </div>
        ) : type === "search" ? (
          <div className="basic-form d-flex">
            {value !== undefined && value !== null && value !== "" ? (
              <input
                key={name}
                className="form-control mr-2"
                type="text"
                name={name}
                value={value}
                onChange={onChange}
                disabled={disabled || viewonly}
                required={required}
              />
            ) : (
              <input
                key={name}
                className="form-control mr-2"
                type="text"
                name={name}
                defaultValue={initailValue}
                onChange={onChange}
                disabled={disabled || viewonly}
                required={required}
              />
            )}
            <button className="btn btn-primary btn-sm" onClick={onSearch}>
              Search
            </button>
          </div>
        ) : null}
      </div>
    </div>
  );
};
